
import BaseModel from '../../helpers/basemodel'
import alert from '../../helpers/alert'
import Api from '../../helpers/api'
import moment from 'moment'
import QueryString from '../../helpers/query-string'

/**
 * Const
 *
 */
const api = new Api()



/**
 * State
 *
 */
const state = {
  ...BaseModel.state,

  itemlist: [],
  paymentlist: [],
}


/**
 * Getters
 *
 */
const getters = {
  ...BaseModel.getters,

  listOptions({ listOptions: opt }) {
    const query = new QueryString([
      `limit=${opt.pagelimit}`,
      `skip=` + (opt.pagenumber - 1) * opt.pagelimit,
      `type=report`,
    ])

    if (opt.format) query.push(`format=${opt.format}`)
    if (opt.search) query.push(`search=${opt.search}`)
    if (opt.datefrom) query.push(`datefrom=${opt.datefrom}`)
    if (opt.dateto) query.push(`dateto=${opt.dateto}`)

    return query.string
  },

  data({ selectedObject: item }) {
    if (!Object.keys(item).length) return {}

    return {
      ...item,
      get cost_delivery_readable() {
        return this.cost_delivery.toLocaleString()
      },
      get total_sales_readable() {
        return this.total_sales.toLocaleString()
      },
      get total_paid_readable() {
        return this.total_paid.toLocaleString()
      },
      get total_unpaid() {
        return this.total_sales - this.total_paid
      },
      get total_unpaid_readable() {
        return this.total_unpaid.toLocaleString()
      },
      get locked_date_readable() {
        if (!this.locked_date) return ``
        return moment(this.locked_date).format(`DD/MM/YYYY HH:mm:ss`)
      },
      get date_ordered_readable() {
        if (!this.date_ordered) return ``
        return moment(this.date_ordered).format(`DD/MM/YYYY`)
      },
      get date_sent_readable() {
        if (!this.date_sent) return ``
        return moment(this.date_sent).format(`DD/MM/YYYY`)
      },
      get date_paid_readable() {
        if (!this.date_paid) return ``
        return moment(this.date_paid).format(`DD/MM/YYYY`)
      },
      get use_store_discount_readable() {
        if (this.use_store_discount) return `Harga Toko`
        return `Harga Customer`
      },
      get isDraft() {
        if (this.locked) return false
        return (this.status_order === `DRAFT`)
      },
      get isOrdered() {
        if (this.locked) return true
        return this.status_order === `ORDERED`
      },
      get isSent() {
        if (this.locked) return true
        return this.status_order === `SENT`
      },
      get isCanceled() {
        if (this.locked) return true
        return this.status_order === `CANCELED`
      },
      get isPaid() {
        if (this.locked) return true
        if (this.status_order === `DRAFT`) return false
        return this.status_paid
      },
    }
  },

  list({ list }) {
    return list.map((item) => ({
      ...item,
      get date_ordered_readable() {
        if (!this.date_ordered) return ``
        return moment(this.date_ordered).format(`DD/MM/YYYY`)
      },
      get total_sales_readable() {
        return this.total_sales.toLocaleString()
      },
    }))
  },

  itemlist({ itemlist }) {
    return itemlist.map((item) => ({
      ...item,
      get price_unit_readable() { return this.price_unit.toLocaleString() },
      get subtotal() { return this.price_unit * this.quantity },
      get subtotal_readable() { return this.subtotal.toLocaleString() },
    }))
  },

  paymentlist({ paymentlist }) {
    return paymentlist.map((item) => ({
      ...item,
      get amount_readable() { return this.amount.toLocaleString() },
      get date_readable() {
        if (!this.date) return ``
        return moment(this.date).format(`DD/MM/YYYY`)
      },
    }))
  },
}


/**
 * Actions
 *
 */
const actions = {
  ...BaseModel.actions,

  async fetchList({ commit, getters }) {
    commit(`loading_mode`, 1)

    return api.get(`/sales?` + getters.listOptions)
      .then(({ data, nrecord }) => {
        commit(`loading_mode`, 0)
        commit(`set_list`, data)
        commit(`set_nrecord`, nrecord)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async fetchOptions({ commit, getters }) {
    commit(`loading_mode`, 1)

    return api.get(`/sales?format=options`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_options`, data)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async fetchData({ commit }, id) {
    if (!id) return commit(`clear_selected_object`)

    commit(`loading_mode`, 1)

    return api.get(`/sales/${id}`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_selected_object`, data)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async refetchData({ dispatch }) {
    const id = state.selectedObject.id
    return dispatch(`fetchData`, id)
  },

  async fetchListItem({ commit, state }) {
    const id = state.selectedObject.id

    if (!id) return commit(`clear_listitem`)

    commit(`loading_mode`, 1)

    return api.get(`/sales/${id}/item`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_listitem`, data)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async fetchListPayment({ commit, state }) {
    const id = state.selectedObject.id

    if (!id) return commit(`clear_listpayment`)

    commit(`loading_mode`, 1)

    return api.get(`/sales/${id}/payment`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_listpayment`, data)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async update({ commit, dispatch, rootState }, { id, data }) {
    commit(`loading_mode`, 1)

    if (!id) id = ``

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)

      if (id) alert.success(`Data berhasil diupdate`)
      else alert.success(`Data berhasil ditambahkan`)

      return result.id
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    return api.put(`/sales/${id}`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async lock({ commit, dispatch, rootState }) {
    commit(`loading_mode`, 1)

    const id = state.selectedObject.id
    if (!id) return onerror()

    const onsuccess = async () => {
      commit(`loading_mode`, 0)
      alert.success(`Data berhasil diupdate`)
      return id
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    return api.post(`/sales/${id}/lock`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async tagtoOrder({ commit, dispatch, rootState }) {
    commit(`loading_mode`, 1)

    const onsuccess = async () => {
      commit(`loading_mode`, 0)
      alert.success(`Data berhasil diupdate`)
      return id
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    const id = state.selectedObject.id
    if (!id) return onerror()

    return api.post(`/sales/${id}/order`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async tagtoSent({ commit, dispatch, rootState }) {
    commit(`loading_mode`, 1)

    const onsuccess = async () => {
      commit(`loading_mode`, 0)
      alert.success(`Data berhasil diupdate`)
      return id
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    const id = state.selectedObject.id
    if (!id) return onerror()

    return api.post(`/sales/${id}/send`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async tagtoCanceled({ commit, dispatch, rootState }) {
    commit(`loading_mode`, 1)

    const onsuccess = async () => {
      commit(`loading_mode`, 0)
      alert.success(`Data berhasil diupdate`)
      return id
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    const id = state.selectedObject.id
    if (!id) return onerror()

    return api.post(`/sales/${id}/cancel`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async remove({ commit, rootState }, id) {
    commit(`loading_mode`, 1)

    const onsuccess = async () => {
      commit(`loading_mode`, 0)
      alert.success(`Data berhasil dihapus`)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    return api.delete(`/sales/${id}`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async updateListItem({ commit, dispatch, state, rootState }, data) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    const id = state.selectedObject.id
    if (!id) return onerror()

    return api.put(`/sales/${id}/item`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async removeListItem({ commit, dispatch, state, rootState }, data) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    const id = state.selectedObject.id
    if (!id) return onerror()

    return api.delete(`/sales/${id}/item`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async pay({ commit, dispatch, getters, rootState }, data) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      if (err.message) alert.danger(err.message)
      return 0
    }

    if (!rootState.Auth.permission.includes(`ACCESS_SALES_M`)) {
      return onerror({ message: `Anda tidak memiliki permission untuk mengedit data ini `})
    }

    const obj = getters.data
    if (!obj.id) return onerror()

    if (!data.method_id) {
      return onerror({ message: `Metode bayar belum terpilih` })
    }

    if (data.amount > obj.total_unpaid) {
      return onerror({ message: `Jumlah lebih besar daripada tagihan` })
    }

    return api.post(`/sales/${obj.id}/pay`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },
}

/**
 * Mutations
 *
 */
const mutations = {
  ...BaseModel.mutations,

  set_listitem(state, list) {
    state.itemlist = list
  },

  clear_listitem(state) {
    state.itemlist = []
  },

  set_listpayment(state, list) {
    state.paymentlist = list
  },

  clear_listpayment(state) {
    state.paymentlist = []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}